module.exports = __webpack_public_path__ + "static/media/farm.e58c3667.svg";